import React from "react";
import { useTranslation } from "utilities/i18n";
import PolyIcon from "../PolyIcon";
import { ClipboardProps, useClipboard } from "../Clipboard";

export interface CopyToClipboardButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    ClipboardProps {
  icon?: string;
  iconClassName?: string;
  iconButton?: boolean;
}

export const CopyToClipboardButton: React.FC<CopyToClipboardButtonProps> = ({
  icon,
  iconClassName,
  iconButton,
  getTextToCopy,
  notify = true,
  notifyName,
  onCopyText,
  className,
  children,
  type,
  onClick,
  ...otherProps
}) => {
  const { t } = useTranslation();

  const clipboard = useClipboard({
    notify: notify,
    notifyName,
    onCopyText
  });

  const onClickHandler = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    // not strictly necessary due to `type="button"`, but additional safety measure
    e.preventDefault();

    const promise = clipboard.copyText(getTextToCopy());
    if (onClick) {
      promise.finally(() => {
        onClick(e);
      });
    }
  };

  const aType = type || "button";
  const aIcon = icon ?? "clipboard";

  return (
    <button
      type={aType}
      className={[iconButton ? "btn-poly-icon" : "btn", className]
        .filter(c => !!c)
        .join(" ")}
      data-testid="copy-to-clipboard-button"
      onClick={onClickHandler}
      {...otherProps}
    >
      {aIcon && <PolyIcon className={iconClassName} icon={aIcon} />}
      {iconButton ? children : children || t("COPY")}
    </button>
  );
};
